import { Identify } from '@amplitude/analytics-browser'
import { EligibilitySubmission } from '../../global'
import { i18n } from '../../i18n'
import amplitudeModule from './amplitude'
import { EnrollmentClient, Technique } from './client'
import { Action, Actor, buildEventName, Context, Namespace } from './event'

const amplitude = amplitudeModule.getClient()

const client: EnrollmentClient = {
    identify(submission: EligibilitySubmission): void {
        const identifyEvent = new Identify()

        identifyEvent.set('campaign_id', submission.campaignId)
        identifyEvent.set('partner_type', submission.partner.type)
        identifyEvent.set('partner_name', submission.partner.name)
        identifyEvent.set('lang', i18n.global.locale.value)

        amplitude.identify(identifyEvent)
        amplitude.setUserId(submission.id)
    },
    track(actor: Actor, action: Action, context: Context = {}): void {
        amplitude.track(buildEventName(Namespace.Enrollment, actor, action), context)
    },
    trackTechniques(techniques: Technique[]): void {
        const identifyEvent = new Identify()

        identifyEvent.set(
            'techniques',
            techniques.map((technique) => technique.key ?? technique.name)
        )
        identifyEvent.set(
            'technique_ids',
            techniques.map((technique) => technique.id)
        )

        amplitude.identify(identifyEvent)
    },
}

export default client
